import { FileUIPart } from 'ai';
import { RachelAskUserOutput, RachelMessageReference, RachelUIMessage } from './rachel.contract';
import { RachelPageContext } from './rachelPageContext.types';

export type { RachelMessageReference, RachelUIMessage };

export enum RachelChatStatus {
  SUBMITTED = 'SUBMITTED',
  STREAMING = 'STREAMING',
  READY = 'READY',
  ERROR = 'ERROR',
}

export enum RachelToolName {
  SHOW_VISUALIZATIONS = 'exibir_visualizacoes',
  EXECUTE_CODE = 'executar_codigo',
  LIST_CONTEXTS = 'listar_contextos',
  SELECT_CONTEXT = 'selecionar_contexto',
  CURRENT_CONTEXT = 'contexto_atual',
  BILLING_REPORT = 'consultar_faturamento',
  SALES_REPORT = 'consultar_vendas',
  LIST_CATEGORIES = 'listar_categorias',
  LIST_CLASSIFICATIONS = 'listar_classificacoes',
  LIST_COLLECTIONS = 'listar_colecoes',
  LIST_CUSTOMERS = 'listar_clientes',
  LIST_CUSTOMER_ADDRESSES = 'listar_enderecos_cliente',
  LIST_DELIVERY_WINDOWS = 'listar_janelas_entrega',
  LIST_REPRESENTATIVES = 'listar_representantes_do_cliente',
  CREATE_ORDER = 'criar_pedido',
  UPDATE_ORDER = 'atualizar_pedido',
  SEARCH_ORDERS = 'buscar_pedidos',
  EDIT_ORDER_ITEMS = 'editar_itens_pedido',
  REMOVE_ORDER_ITEMS = 'remover_itens_pedido',
  CHANGE_ORDER_STATUS = 'alterar_status_pedido',
  SEARCH_ORDER_CONDITIONS = 'buscar_condicoes_pedido',
  UPDATE_ORDER_CONDITION = 'atualizar_condicao_pedido',
  LIST_ORDER_CONDITION_PAYMENT_METHODS = 'listar_formas_pagamento_condicao_pedido',
  LIST_ORDER_DISCOUNTS = 'listar_descontos_pedido',
  LIST_ORDER_PRODUCTS = 'listar_produtos_pedido',
  SEARCH_PRODUCTS = 'buscar_produtos',
  CREATE_TARGET = 'meta_criar',
  EDIT_TARGET = 'meta_editar',
  DELETE_TARGET = 'meta_excluir',
  GET_TARGET = 'meta_consultar',
  LIST_TARGETS = 'meta_listar_metas',
  LIST_BREAKDOWN_ITEMS = 'meta_listar_itens_quebra',
  DEFINE_PLANNED = 'meta_definir_planejado',
  REMOVE_PLANNED_ITEM = 'meta_remover_item_planejado',
  GET_SELLOUT_STOCK = 'consultar_vendas_estoque',
}

export interface RachelOutgoingMessage {
  text: string;
  files?: FileUIPart[];
}

export interface UseRachelChatReturn {
  messages: RachelUIMessage[];
  status: RachelChatStatus;
  error: Error | undefined;
  isStreaming: boolean;
  currentPageContext: RachelPageContext;
  replacementPageContext: RachelPageContext | null;
  isPageContextDismissed: boolean;
  dismissPageContext: () => void;
  sendMessage: (message: RachelOutgoingMessage) => void;
  stop: () => Promise<void>;
  addToolApprovalResponse: (id: string, isApproved: boolean) => void;
  addAskUserAnswer: (toolCallId: string, output: RachelAskUserOutput) => void;
  selectChat: (chatId: string) => Promise<void>;
  startNewConversation: () => Promise<void>;
  attachCurrentPage: (chatId: string, pageContext?: RachelPageContext) => Promise<void>;
  detachPageContext: (chatId: string) => Promise<void>;
}

export interface RachelDockedLayout {
  width: number;
  groupWidth: number;
}
